export const TID = {
  // Landing
  landingEnter: "landing-enter-btn",
  landingHero: "landing-hero",

  // Dashboard
  dashboardTitle: "dashboard-title",
  sectionCard: (id) => `section-card-${id}`,
  historyLink: "history-link",

  // Section page
  sectionTitle: "section-title",
  promptCard: (id) => `prompt-card-${id}`,
  promptText: (id) => `prompt-text-${id}`,
  speakPromptBtn: (id) => `speak-prompt-btn-${id}`,
  recordBtn: (id) => `record-btn-${id}`,
  stopBtn: (id) => `stop-btn-${id}`,
  transcriptArea: (id) => `transcript-area-${id}`,
  saveEntryBtn: (id) => `save-entry-btn-${id}`,
  reflectBtn: (id) => `reflect-btn-${id}`,
  reflectionText: (id) => `reflection-text-${id}`,
  backToDashboard: "back-to-dashboard",

  // History
  historyTitle: "history-title",
  entryItem: (id) => `entry-item-${id}`,
  deleteEntryBtn: (id) => `delete-entry-btn-${id}`,
};
